export const AD_CLICK_EVENT = {
	ACTION: 'AdClick',
	CATEGORY: 'ad'
}
